import React from "react";
import I from "./Icon";
const BC = ({ items, onBack }) => (
  <div className="bc">
    <span className="bc-back" onClick={onBack}><I n="chevL" s={14} />Back</span>
    {items.map((it, i) => (
      <span key={i} style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span className="bc-sep">›</span>
        <span className={i === items.length - 1 ? "bc-cur" : ""}>{it}</span>
      </span>
    ))}
  </div>
);

export default BC;